import { render, staticRenderFns } from "./ApproachPage.vue?vue&type=template&id=05c592ef&scoped=true&"
import script from "./ApproachPage.vue?vue&type=script&lang=js&"
export * from "./ApproachPage.vue?vue&type=script&lang=js&"
import style0 from "./ApproachPage.vue?vue&type=style&index=0&id=05c592ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c592ef",
  null
  
)

export default component.exports